import { z } from 'zod';

import { ChatUiMoneySchema } from '../../shared/schema/money_schema.js';
import { chatUiBase } from '../../shared/schema/base.js';

export const ChatUiHotelRateWarningSchema = z
  .object({
    offerId: z.string().min(1),
    roomIndex: z.number().int().positive(),
    property: z.string().min(1),
    room: z.string().min(1).optional(),
    /** O total REPRECIADO (quote do fornecedor); `previousPrice` é o capturado
     *  que a pessoa viu ao escolher — o card mostra o par para a decisão ver o
     *  delta, não só "mudou". Aditivo: bloco antigo sem o campo renderiza como
     *  sempre (replay de histórico). */
    price: ChatUiMoneySchema.optional(),
    previousPrice: ChatUiMoneySchema.optional(),
    warnings: z.array(z.string().trim().min(1).max(500)).min(1).max(5),
  })
  .strict();
export type ChatUiHotelRateWarning = z.infer<typeof ChatUiHotelRateWarningSchema>;

export const HotelRateWarningBlockSchema = z
  .object({
    ...chatUiBase,
    kind: z.literal('hotel_rate_warning'),
    warning: ChatUiHotelRateWarningSchema,
  })
  .strict();
